import React from "react";

import {
  ChannelType,
  DeviceType,
  StatSigViewType,
  VisitorType,
} from "@intelligems/ig-types";

import {
  Visitor,
  VisitorRadio,
} from "../../../components/AudienceFilters/Visitor";

interface VisitorTypeFilterProps {
  onStringFilterChange: (
    newValue: DeviceType | VisitorType | ChannelType | StatSigViewType,
    filterKey: "statSigView" | "deviceType" | "channelType" | "visitorType"
  ) => void;
  visitorType?: VisitorType | null;
}

export const VisitorTypeFilter = ({
  visitorType,
  onStringFilterChange,
}: VisitorTypeFilterProps) => {
  return (
    <VisitorRadio visitorType={visitorType} onClick={onStringFilterChange} />
  );
};
